import updateTree from './updateTree'

export default function creditBalance(state = {}, action) {
  switch (action.type) {

    case 'SET_SEATTLE_DRIVER_STATUS': {
      return updateTree(state, 'seattleDriver', () => action.data)
    }

    default:
      return {
        seattleDriver: false,
        ...state
      }
  }
}